const BatchStatus = {
  Unknown: -1,
  New: 0,
  FilesPrepared: 1,
  ReceivedByGateway: 2,
  FilesQueued: 3,
  Processed: 4,
  Failed: 5,
  FailedInvalidCoverSheet: 6,
  FailedInvalidClientInCoverSheet: 7,
  NoFormsFound: 8,
  Completed: 9
};

export default BatchStatus;
